import { NoResultsWithButton } from "components";
import { CreateButton } from "./CreateButton";
import { faFolderOpen } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";

export interface Props {
  filtered: boolean;
}

export const NoResults = (props: Props) => {
  return (
    <NoResultsWithButton
      title="No SCORM Packages"
      description="Looks like you haven’t imported any SCORM Packages yet."
      actionText="Drag and drop files or select the button below to import."
      icon={<FontAwesomeIcon icon={faFolderOpen} color={"#DEDEDE"} size={"10x"} />}
      actionButton={<CreateButton />}
      filtered={props.filtered}
    />
  );
};
